import React from 'react'
import Pace from 'react-pace-progress'

import '../../static/css/paceloader.css'

const PaceLoader = ({ isLoading, style = {} }) => {
  if (!isLoading) return null

  return (
    <div
      className="clearout-loader d-flex g-0"
      style={style}
    >
      <Pace height={3} />
    </div>
  )
}

export default PaceLoader
